import BulletPoints from 'components/BulletPoints';
import React from 'react';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

import * as S from './styles';
import { HeroCategorySectionProps } from './types';

export default function HeroCategorySection({
  content,
  onCtaClick,
  setClickedFaqId,
}: HeroCategorySectionProps): JSX.Element | null {
  if (!content) return null;
  const { headline, description, desktopImage, bulletPoints, cta } = content;

  const onBulletClick = (bulletText: string, hyperlinkId: string) => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        label: bulletText,
      },
    });
    // Set the bullet point's anchor link FAQ ID when clicked
    // so it will scroll to the correct FAQ accordion
    // and the accordion will open to the FAQ's answer
    if (hyperlinkId && setClickedFaqId) {
      setClickedFaqId(hyperlinkId);
    }
  };

  const handleCtaClick = () => {
    if (onCtaClick) {
      onCtaClick();
    }

    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        sectionHeader: headline,
        contentfulSection: 'HeroCategorySection',
        ctaText: cta?.text,
      },
    });
  };

  return (
    <S.Container>
      <S.HeroContent>
        <S.HeroContentWrapper>
          <S.Headline>{headline}</S.Headline>
          <S.DescriptionText>{description?.description}</S.DescriptionText>
          <S.BulletContent>
            {bulletPoints ? (
              <BulletPoints
                bulletPoints={bulletPoints}
                onClick={onBulletClick}
              />
            ) : null}
          </S.BulletContent>
          {cta ? (
            <S.ButtonWrapper appearance="primary" onClick={handleCtaClick}>
              {cta.text}
            </S.ButtonWrapper>
          ) : null}
        </S.HeroContentWrapper>
      </S.HeroContent>
      <S.HeroImageWrapper>
        {desktopImage && (
          <S.HeroImage
            image={desktopImage.gatsbyImageData}
            alt={desktopImage.description}
          />
        )}
      </S.HeroImageWrapper>
    </S.Container>
  );
}
